// DEBT-VITA™ — Tooltip d'aide simple pour les champs du formulaire dette
// (Variante allégée de FieldHelp, sans deep-link tutoriel — un Chapitre 11
// dédié sera ajouté en Phase 5 du masterplan.)
import React from "react";
import { HelpCircle } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

export default function DebtFieldHelp({ id, title, description }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={`Aide sur ${title}`}
          data-testid={`debt-help-${id}`}
          className="ml-1 inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full text-amber-600 transition-colors hover:bg-amber-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500 dark:text-amber-400 dark:hover:bg-amber-950"
        >
          <HelpCircle className="h-3.5 w-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        side="top"
        align="start"
        className="w-72 rounded-xl border border-amber-300/40 bg-card p-3 text-sm shadow-xl"
        data-testid={`debt-help-${id}-content`}
      >
        <div className="text-[11px] font-bold uppercase tracking-widest text-amber-700 dark:text-amber-400">
          {title}
        </div>
        <p className="mt-2 text-xs leading-relaxed text-foreground/85">
          {description}
        </p>
      </PopoverContent>
    </Popover>
  );
}
